"use es6";

import { createHtmlRenderState } from "../../html/utils/create-render-state";
const createSvgRenderState = () => Object.assign({}, createHtmlRenderState(), {
  attrs: {}
});
export { createSvgRenderState };